import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'situ-product-readonly',
  templateUrl: './situ-product-readonly.component.html',
  styleUrls: ['./situ-product-readonly.component.scss']
})
export class SituProductReadonlyComponent implements OnInit {
  @Input() routeParams: any;
  
  /* view high level controls */
  paramId: string | undefined;
  url: string | undefined;
  urlIos: string | undefined;
  posterUrl: string | undefined;

  /* view data */
  productWidth: number | undefined;

  @ViewChild('modelContainer') modelContainer: ElementRef | undefined;

  constructor(
    private snackBar: MatSnackBar,
    private configService: ConfigService) {}

  ngOnInit(): void {
    if (this.routeParams['id']) {
      this.url = `${this.configService.config.situViewWebApiBaseUrl}/home/getglb?artifactId=${this.routeParams['id']}&fileName=product.glb`;
      this.urlIos = `${this.configService.config.situViewWebApiBaseUrl}/home/getglb?artifactId=${this.routeParams['id']}&fileName=product.usdz`;
      this.posterUrl = `${this.configService.config.situViewWebApiBaseUrl}/home/getimage?artifactId=${this.routeParams['id']}&filename=preview.webp`;
    }
  }

  exposureValue = 0.5;
  shadowIntensityValue = 1;
  onExposureChange(event: any) {
    this.exposureValue = event.value;
  }
  onShadowIntensityChange(event: any) {
    this.shadowIntensityValue = event.value;
  }

  private showMessage(message: string) {
    this.snackBar.open(message, 'OK', { duration: 2000 });
  }
}